import React from 'react';
export function StartFreeHeroInfo() {
  return <>
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-3088">
        Free One-Week Trial
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-tight" data-id="element-3089">
        Help Your Child Build Confidence - Try Storm Free
      </h1>
      <p className="text-xl text-off-white mb-10 leading-relaxed" data-id="element-3090">
        Storm Taekwondo gives kids a structured, positive place to build
        discipline, focus, fitness and resilience. See the difference in just
        one week.
      </p>
    </>;
}